export class QuantiteDossierRecouvrementSuiviPortefeuilleDTO {
         nombreImpaye: number;
         nombrePrecontentieux: number;
         nombreContentieux: number;
         nombreIrrecouvrable: number;
       }